// extracted by mini-css-extract-plugin
module.exports = {"table":"guesshistory_table__tbRM9","game_history":"guesshistory_game_history__3d0eN"};